<template>
  <div class="advantagePosition">
    <div class="compText">
      “保险+科技”公司致力于为代理人提供线上线下一体化一站式智能化平台服务
    </div>
    <div class="positionImg">
      <img src="../assets/images/picture_06.png" alt="">
    </div>
    <div class="positionImg positionImage" style="margin-top:60px;">
      <img src="../assets/images/picture_07.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'advantagePosition',
    components: {},
    data() {
      return {
        
      }
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .advantagePosition {
    width: 1024px;
    margin: 0 auto;
    &>div {
      margin-top: 30px;
      position: relative;

      .ideaText {
        width: 100%;
        color: #ffffff;
        position: absolute;
        top: 170px;
        text-align: center;

        &>div:first-child {
          font-weight: 600;
        }
      }

      img {
        width: 100%;
      }
    }
    .highLightTitle{
      text-align: center;
    }
    .positionImg{
      width: 1024px;
      height: 450px;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
      padding: 40px 0 0 150px;
      img{
        width: 712px;
      }
    }
    .positionImage{
      padding: 40px 0 0 190px;
      img{
        width: 656px;
      }
    }

  }
</style>